// src/route.svelte.ts
export type Route =
  | { name: 'home' }
  | { name: 'chat'; id: string }
  | { name: 'biblioteca' }
  | { name: 'biblioteca-document'; documentId: number }
  | { name: 'seguimiento' }
  | { name: 'seguimiento-detalle'; seguimientoId: number };

let currentRoute = $state<Route>({ name: 'home' });

export function parsePath(path: string): Route {
  const clean = path.split('?')[0].split('#')[0];
  if (clean.startsWith('/chat/')) {
    const id = clean.slice('/chat/'.length) || 'temp-id';
    return { name: 'chat', id };
  }

  if (clean === '/biblioteca' || clean === '/biblioteca/') {
    return { name: 'biblioteca' };
  }

  const bibliotecaDocumentMatch = clean.match(/^\/biblioteca\/(\d+)\/?$/);
  if (bibliotecaDocumentMatch) {
    return {
      name: 'biblioteca-document',
      documentId: Number(bibliotecaDocumentMatch[1]),
    };
  }

  if (clean === '/seguimiento-judicial' || clean === '/seguimiento-judicial/') {
    return { name: 'seguimiento' };
  }

  const seguimientoDetalleMatch = clean.match(
    /^\/seguimiento-judicial\/seguimiento\/(\d+)\/?$/,
  );
  if (seguimientoDetalleMatch) {
    return {
      name: 'seguimiento-detalle',
      seguimientoId: Number(seguimientoDetalleMatch[1]),
    };
  }

  return { name: 'home' };
}

export function initRouter() {
  currentRoute = parsePath(window.location.pathname);

  window.addEventListener('popstate', () => {
    currentRoute = parsePath(window.location.pathname);
  });
}

export function navigate(path: string) {
  if (window.location.pathname === path) return;
  window.history.pushState({}, '', path);
  currentRoute = parsePath(path);
}

export function getRoute() {
  return currentRoute;
}
